<template>
  <div>
    <full-calendar
      ref="fullCalendar"
      default-view="timeGridWeek"
      :header="{
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay,listMonth'
      }"
      :week-numbers="true"
      :events="events"
      :plugins="calendarPlugins"
      theme-system="bootstrap"
      @eventClick="onEventClick"
    ></full-calendar>
  </div>
</template>

<style lang="scss">
@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';
@import '~@fullcalendar/timegrid/main.css';
@import '~@fullcalendar/bootstrap/main.css';

.fc-event {
  color: white;
}
</style>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import bootstrapPlugin from '@fullcalendar/bootstrap';
import moment from 'moment'
import { getCalendarItems } from '@/api'
import { rrulestr } from 'rrule'

const testEvents = [
  {
    title: 'Simple Event',
    start: moment().startOf('week').format('YYYY-MM-DD\T09:00:00'),
    end: moment().startOf('week').format('YYYY-MM-DD\T10:00:00'),
  },
  {
    title: 'All Day Event',
    // just specifying date implies an all day event
    date: moment().startOf('week').add(1, 'day').format('YYYY-MM-DD')
  },
  {
    title: 'Multi-Day Event',
    allDay: true,
    start: moment().startOf('week').add(1, 'day').format('YYYY-MM-DD'),
    end: moment().startOf('week').add(4, 'days').format('YYYY-MM-DD')
  }
]

export default {
  components: {
    FullCalendar // make the <FullCalendar> tag available
  },
  data() {
    return {
      calendarPlugins: [
        dayGridPlugin,
        timeGridPlugin,
        bootstrapPlugin,
        listPlugin
      ],
      calendarApi: null,
      server: {
        items: [],
        calendars: [],
        filters: []
      }
    }
  },
  computed: {
    events () {
      let events = []
      for(let i in this.server.items) {
        let item = this.server.items[i]
        if (!item.repeat) {
          let itemStartAt = moment(item.start_at)
          let itemEndAt = moment(item.end_at)

          if (item.all_day) {
            events.push({
              title: item.summary,
              start: itemStartAt.format('YYYY-MM-DD'),
              end: itemEndAt.format('YYYY-MM-DD'),
              allDay: true
            })
          } else {
            events.push({
              title: item.summary,
              start: itemStartAt.format('YYYY-MM-DD\THH:mm:ss'),
              end: itemEndAt.format('YYYY-MM-DD\THH:mm:ss'),
            })
          }
        } else {

        }
      }
      return events
    }
  },
  mounted () {
    this.calendarApi = this.$refs.fullCalendar.getApi()

    this.calendarApi.on('datesRender', () => {
      this.loadEvents()
    })

    this.loadEvents()
  },
  methods: {
    async loadEvents () {
      let date = this.calendarApi.getDate()
      let response = await getCalendarItems(
        moment(date).add(-30, 'days').format('YYYY-MM-DD'),
        moment(date).add(30, 'days').format('YYYY-MM-DD')
      )
      this.server = response.data
    },
    onEventClick () {
      console.log(arguments)
    }
  }
}
</script>